// client/src/App.js

import {
  AlertDialog,
  AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay,
  Box,
  Button,
  Center,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Progress,
  Select,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Tfoot,
  Th,
  Thead,
  Tr,
  useToast
} from '@chakra-ui/react';
import axios from "axios";
import React, { useEffect, useState } from 'react';
import { AiFillStepBackward, AiFillStepForward } from "react-icons/ai";
import { FaSortDown, FaSortUp } from "react-icons/fa";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";
import "../../App.css";
import CommonContext from '../../commonContext';
import { postCall } from '../../utils/requests';
import { utilConstants } from '../../utils/utilConstants';
import Utils from '../../utils/utils';

function CompetitionsList() {

  /* TODO const navigate = useNavigate(); */
  const commonContext = React.useContext(CommonContext);

  const logout = () => {
    console.log("logout")
    localStorage.removeItem("accessToken");
    /* TODO navigate('/'); */
  }

  /* utils */
  const toast = useToast();
  const fileRef = React.useRef(null);

  /* table */
  const [tableContent, setTableContent] = useState([]);
  const [allData, setAllData] = useState([]);

  /* delete form */
  const [isOpenDelete, setIsOpenDelete] = React.useState(false)
  const [isOpenCreate, setIsOpenCreate] = React.useState(false)
  const [isOpenEdit, setIsOpenEdit] = React.useState(false)
  const [idToDelete, setIdToDelete] = React.useState(null)
  const [idToUpdate, setIdToUpdate] = React.useState(null)
  const [nameToDelete, setNameToDelete] = React.useState("")
  const [page, setPage] = React.useState(1)
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(null);
  const [title, setTitle] = useState("");
  const [linkYt, setLinkYt] = useState("");
  const [description, setDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [hidden, setHidden] = useState(false);
  const [premium, setPremium] = useState(false);
  const [idCategory, setIdCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [updatedChunks, setUpdatedChunks] = useState(0);
  const [totalChunks, setTotalChunks] = useState(0);
  const [allCategories, setAllCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [defaultCat, setDefaultCat] = useState("-1");
  const [toplist, setToplist] = useState(false);
  const [coverPath, setCoverPath] = useState("")
  const [sortOrder, setSortOrder] = React.useState("desc")
  const [sortedBy, setSortedBy] = React.useState("")
  const [startDate, setStartDate] = React.useState(null)

  const [name, setName] = React.useState("")
  const [address, setAddress] = React.useState("")
  const [competitionDate, setCompetitionDate] = React.useState("")
  const [distance, setDistance] = React.useState("")
  const [weblink, setWeblink] = React.useState("")

  const handleFileChange = (event) => {
    setVideo(event.target.files[0]);
  };

  /* BEGIN - video cover */
  const handleVideoCoverChange = async (event) => {

    /* formdata */
    let formData = new FormData();

    //add fields to form
    //formData.append('video', video);
    formData.append('action', 'add')
    formData.append("file", event.target.files[0])

    try {

      const response = await axios.post('/uploadVideoCover', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 0,

      });


      if (response.data.status === "success") {
        /* TODO set iamge url here */
        console.log("uploaded_success")

        setCoverPath(response.data.data.coverPath)
      } else {
        /* TODO STOP PROCESS */
        console.log("upload_error")
      }
    } catch (error) {
      console.log(error)
    }

  };

  /* END - video cover */


  const handleSubmitCompetition = async (event) => {
    event.preventDefault();

    console.log(competitionDate);

    if (name === "" || name === null || name === undefined) {
      toast({
        title: "Errore",
        description: "Scegli un nome",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }

    setLoading(true);
    onCloseCreate()

    try {
      let resp = await postCall("/createCompetition", {
        name: name,
        address: address,
        competition_date: competitionDate + " 00:00:00",
        distance: distance,
        link: weblink
      })
      if (resp !== undefined && resp !== null && resp.status === "success") {
        toast({
          title: "Perfetto",
          description: "Competizione creata",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        setLoading(false);
        fetchCompetitions()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore: " + resp.error,
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        setLoading(false);
      }
    } catch (e) {
      toast({
        title: "Errore",
        description: "Si è verificato un errore",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      setLoading(false);
    }


  };

  const fetchCategories = async () => {
    postCall("/fetchCat", {}).then((data) => {

      setAllCategories(data.data)
      setCategories(Array.from(data.data.map((item) => {
        return (<option key={item.id_category} value={item.id_category}>{item.name}</option>)
      })));
    });
  }

  const updateVideos = async () => {
    postCall("/updateFromLocalVideos", {}).then((data) => {
      console.log(data);
      if (data.status === "success") {
        toast({
          title: "Perfetto",
          description: "I video sono stati aggiornati",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        fetchCompetitions()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore: " + data.error,
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });
  }

  const setDefaultCategory = async (id_category) => {

    setDefaultCat(id_category)


    /*  setCategories(Array.from(allCategories.map((item) => {
 
       console.log(item.id_category, id_category)
       if (item.id_category === id_category) {
         return (<option selected key={item.id_category} value={item.id_category}>{item.name}</option>)
       } else {
         return (<option key={item.id_category} value={item.id_category}>{item.name}</option>)
       }
     }))); */
  }


  const fetchCompetitions = async () => {
    postCall("/fetchCompetitions", {}).then((data) => {


      if (data.status === "success") {




        setAllData(Array.from(data.data.map((item) => {



          return {
            id: item.id_competition,
            name: item.name,
            address: item.address,
            competition_date_en: item.competition_date,
            competition_date: Utils.convertDateToIta(item.competition_date, false),
            distance: item.distance,
            link: item.link,
          }
        })));

        /* put in tableContent only first n element from allData */
        setTableContent(Array.from(data.data.map((item) => {
          return {
            id: item.id_competition,
            name: item.name,
            address: item.address,
            competition_date_en: item.competition_date,
            competition_date: Utils.convertDateToIta(item.competition_date, false),
            distance: item.distance,
            link: item.link,

          }
        })).slice((page * 7) - 7, (page * 7)));

      } else {
        toast({
          title: "Errore",
          description: "Errore nel recupero video",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }
    });
  }

  useEffect(() => {

    fetchCompetitions()
    fetchCategories()

    commonContext.setCurrentPath("Competizioni")
    commonContext.setCurrentPage("competitions")

    return () => {
      // Clean up the interval on component unmount
      clearInterval(timer);
    };

  }, []);


  /* BEGIN - SORTABLE */

  const handleSortCategory = () => {
    setSortedBy("category")
    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => (a.category_name ?? "").localeCompare(b.category_name ?? ""))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => (b.category_name ?? "").localeCompare(a.category_name ?? ""));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {
      /* console.log("item: ", item) */

      return {
        id: item.id,
        name: item.name,
        address: item.address,
        competition_date_en: item.competition_date,
        competition_date: item.competition_date,
        distance: item.distance,
        link: item.link,
      }
    })).slice((page * 7) - 7, (page * 7)));
  };

  const handleSortCreated = () => {
    setSortedBy("created")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.competition_date_en.localeCompare(b.competition_date_en))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.competition_date_en.localeCompare(a.competition_date_en));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        name: item.name,
        address: item.address,
        competition_date_en: item.competition_date,
        competition_date: item.competition_date,
        distance: item.distance,
        link: item.link,

      }
    })).slice((page * 7) - 7, (page * 7)));
  };

  const handleSortTitle = () => {
    setSortedBy("title")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.name.localeCompare(b.name))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.name.localeCompare(a.name));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        name: item.name,
        address: item.address,
        competition_date_en: item.competition_date,
        competition_date: item.competition_date,
        distance: item.distance,
        link: item.link,

      }
    })).slice((page * 7) - 7, (page * 7)));
  };

  /* END - SORTABLE */



  /* BEGIN - EDIT FORM */

  const handleSubmitEdit = async (event) => {
    event.preventDefault();

    if (name === "" || name === null || name === undefined) {
      toast({
        title: "Errore",
        description: "Scegli un nome",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }


    postCall("/updateCompetition", {
      id_competition: idToUpdate,
      name: name,
      address: address,
      competition_date: competitionDate,
      distance: distance,
      link: weblink

    }).then((data) => {
      if (data.status === "success") {

        fetchCompetitions()
        setName("")
        setAddress("")
        setCompetitionDate("")
        setDistance(false)
        setWeblink(false)

        toast({
          title: "Perfetto",
          description: "Competizione modificata",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        onCloseEdit()

      } else {
        toast({
          title: "Errore",
          description: data.error === "15" ? "Questo nome esiste già" : "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });

  }

  const onCloseEdit = async () => {
    setIsOpenEdit(false)
  }

  const openEdit = async (id, name, address, competition_date, distance, weblink) => {

    console.log("competition_date", competition_date)
    let splitted = competition_date.split("T")
    console.log("splitted", splitted[0])
    let date = splitted[0].split("/")[2]
    
    if(splitted[0].split("/")[1].length <2){
      date += "-0" + splitted[0].split("/")[1]
    }else{
      date += "-" + splitted[0].split("/")[1]
    }

    if(splitted[0].split("/")[0].length <2){
      date += "-0" + splitted[0].split("/")[0]
    }else{
      date += "-" + splitted[0].split("/")[0]
    }


    console.log(date)
    setName(name)
    setAddress(address)
    setCompetitionDate(date)
    setDistance(distance)
    setWeblink(weblink)
    setIdToUpdate(id)
    setIsOpenEdit(true)
  }
  /* END - EDIT FORM */


  /* BEGIN - CREATE FORM */

  const onCloseCreate = async () => {
    setIsOpenCreate(false)
  }

  const openCreate = async (id, name) => {
    console.log("openCreate")
    setName("")
    setAddress("")
    setCompetitionDate("")
    setDistance("")
    setWeblink("")
    setIsOpenCreate(true)
  }
  /* END - CREATE FORM */


  /* BEGIN - DELETE FORM */
  const deleteCompetition = async () => {
    console.log("onCloseDelete")


    setIsOpenDelete(false)
    postCall("/deleteCompetition", {
      id_competition: idToDelete
    }).then((data) => {
      if (data.status === "success") {

        /* remove the deleted category from the list */
        setTableContent(tableContent.filter((item) => item.id !== idToDelete))
        setIdToDelete(null)
        setNameToDelete("")

        toast({
          title: "Perfetto",
          description: "Video eliminato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        fetchCompetitions()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });
  }

  const onCloseDelete = async () => {
    setIsOpenDelete(false)
  }

  const openDelete = async (id, name) => {
    console.log("openDelete")
    setIdToDelete(id)
    setNameToDelete(name)
    setIsOpenDelete(true)
  }
  /* END - DELETE FORM */

  return (
    <div style={{ "width": "100%", textAlign: "center", height: "100%", overflowY: "scroll" }}>
      {/* BEGIN - FORM TO EDIT A VIDEO */}
      <Modal isOpen={isOpenEdit} onClose={onCloseEdit}>
        <ModalOverlay />
        <ModalContent maxW="900px">
          <ModalHeader>Modifica competizione</ModalHeader>
          <ModalCloseButton />
          <ModalBody >
            <form onSubmit={handleSubmitEdit}>

              {/* <button type="submit">Upload</button> */}
              <FormControl id="editCompetition">
                <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(2, 1fr)" gap={4}>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Nome</FormLabel>
                    <Input
                      type="text"
                      value={name}
                      onChange={(event) => setName(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Luogo</FormLabel>
                    <Input
                      type="text"
                      value={address}
                      onChange={(event) => setAddress(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Data</FormLabel>
                    {/* TODO */}
                    <Input
                      type="date"
                      value={competitionDate}
                      onChange={(event) => setCompetitionDate(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Distanza</FormLabel>
                    <Input
                      mb="20px"
                      type="text"
                      value={distance}
                      onChange={(event) => setDistance(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Link al sito</FormLabel>
                    <Input
                      mb="20px"
                      type="text"
                      value={weblink}
                      onChange={(event) => setWeblink(event.target.value)}
                    />

                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >


                    {/* BEGIN - video cover */}
                    {/* <FormLabel mt="35px">Copertina</FormLabel>
                    <input type="file" name="videoCover" id="videoCover" onChange={handleVideoCoverChange} />

                    {coverPath !== "" && coverPath !== null && coverPath !== undefined &&
                      (<Box>
                        <Flex justifyContent="center" alignItems="center" height="100%">
                          <Image maxWidth="200" justifyContent="center" src={utilConstants.serverBaseURL + coverPath.replaceAll("images/", "")} alt='Immagine di copertina' />
                        </Flex>
                      </Box>)
                    } */}

                    {/* END - video cover */}
                  </GridItem>
                </Grid>
              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter mt="10px">
            <Button onClick={onCloseEdit} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmitEdit}>Modifica competizione</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO EDIT A VIDEO */}

      {/* BEGIN - FORM TO CREATE A NEW VIDEO */}
      <Modal isOpen={isOpenCreate} onClose={onCloseCreate}>
        <ModalOverlay />
        <ModalContent maxW="900px">
          <ModalHeader>Aggiungi nuova competizione</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form>
              <FormControl id="newCompetition">

                <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(2, 1fr)" gap={4}>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Nome</FormLabel>
                    <Input
                      type="text"
                      value={name}
                      onChange={(event) => setName(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Luogo</FormLabel>
                    <Input
                      type="text"
                      value={address}
                      onChange={(event) => setAddress(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Data</FormLabel>
                    {/* TODO */}
                    <Input
                      type="date"
                      value={competitionDate}
                      onChange={(event) => setCompetitionDate(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Distanza</FormLabel>
                    <Input
                      mb="20px"
                      type="text"
                      value={distance}
                      onChange={(event) => setDistance(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Link al sito</FormLabel>
                    <Input
                      mb="20px"
                      type="text"
                      value={weblink}
                      onChange={(event) => setWeblink(event.target.value)}
                    />

                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >


                    {/* BEGIN - video cover */}
                    {/* <FormLabel mt="35px">Copertina</FormLabel>
                    <input type="file" name="videoCover" id="videoCover" onChange={handleVideoCoverChange} />

                    {coverPath !== "" && coverPath !== null && coverPath !== undefined &&
                      (<Box>
                        <Flex justifyContent="center" alignItems="center" height="100%">
                          <Image maxWidth="200" justifyContent="center" src={utilConstants.serverBaseURL + coverPath.replaceAll("images/", "")} alt='Immagine di copertina' />
                        </Flex>
                      </Box>)
                    } */}

                    {/* END - video cover */}
                  </GridItem>
                </Grid>
              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter mt="10px">
            <Button onClick={onCloseCreate} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmitCompetition}>Carica competizione</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO CREATE A NEW VIDEO */}

      {/* BEGIN - BACK BUTTON */}
      {/* <Stack mt="5" ml="2" mb="5" mr="15" direction='row' spacing={4}>
        <Center><IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          icon={<IoMdArrowRoundBack />}
        /></Center>
        <Box w="5%"></Box>
        <Center >
          <Text
            fontSize="4xl"
            as="b"
            color="teal">
            {commonContext.currentPath}
          </Text>
        </Center>
      </Stack> */}
      {/* END - BACK BUTTON */}

      <hr></hr>

      {/* BEGIN - TOP ROW */}
      <Stack pr="20px" mt="2%" ml="2" mb="10" direction='row' spacing={4} justifyContent="space-between">
        <Button leftIcon={<MdAdd />} colorScheme='green' variant='solid' onClick={openCreate}>
          Aggiungi competizione
        </Button>
        {/* <Button ml="20" leftIcon={<MdAdd />} colorScheme='green' variant='solid' onClick={updateVideos}>
          AGGIORNA
        </Button> */}
        <Input
          borderColor="black"
          w="20%"
          placeholder="Cerca..."
          type="text"
          value={search}
          onChange={(event) => {
            setSearch(event.target.value)
            setTableContent(allData.filter((item) => item.name.toLowerCase().includes(event.target.value.toLowerCase())))
          }}
        />
      </Stack>
      {/* END - TOP ROW */}

      {/* BEGIN - Legend */}

      {/*  <Flex ml="2" mb="5px">
        <HStack>
          <Text fontSize="md" as="b" color="teal">Legenda:</Text>
          <IconButton
            colorScheme='orange'
            aria-label='Call Segun'
            size="sm"
            icon={<HiOutlineBadgeCheck size={20} />}
          /> <Text fontSize="sm" color="teal" > = Premium, </Text> <IconButton
            colorScheme='yellow'
            aria-label='Call Segun'
            size="sm"
            icon={<AiFillEye size={20} color="white" />}
          />  <Text fontSize="sm" color="teal" >= Nascosto, </Text> <IconButton
            colorScheme='green'
            aria-label='Call Segun'
            size="sm"
            icon={<AiFillStar size={20} />}
          />  <Text fontSize="sm" color="teal" >= In evidenza </Text>
        </HStack>
      </Flex> */}
      {/* END - Legend */}

      {/* BEGIN - DELETE FROM */}
      <AlertDialog
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Elimina competizione
            </AlertDialogHeader>

            <AlertDialogBody>
              Vuoi eliminare definitivamente la competizione "{nameToDelete}"?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={onCloseDelete}>
                Indietro
              </Button>
              <Button colorScheme='red' onClick={deleteCompetition} ml={3}>
                Elimina
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {/* END - DELETE FORM */}
      {allData.length < 1 && <Flex h="300px" alignItems="center" justifyContent="center">
        <Text fontSize="xl" as="b" color="teal">Nessuna competizione</Text>
      </Flex>}
      {/* BEGIN - TABLE */}
      {allData.length > 0 && <TableContainer h="100%" >
        <Table variant='striped' colorScheme='blue' w="100%" sx={{ tableLayout: "fixed" }}>
          {/* <TableCaption>Elenco delle categorie</TableCaption> */}
          <Thead>
            <Tr>
              <Th w="2%">ID</Th>
              <Th w="10%" _hover={{ cursor: "pointer" }} onClick={handleSortTitle}>Nome    {sortedBy === "title" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "title" && sortOrder === "desc" && <FaSortUp />}</Th>
              <Th w="18%" >Luogo</Th>
              <Th w="5%" _hover={{ cursor: "pointer" }} onClick={handleSortCreated}>Data  {sortedBy === "created" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "created" && sortOrder === "desc" && <FaSortUp />}</Th>
              <Th w="5%" >Distanza</Th>
              <Th w="12%" >Link</Th>
              <Th w="5%"></Th>
            </Tr>
          </Thead>
          <Tbody>
            {tableContent.map((item) => (
              <Tr key={item.id}>
                <Td>{item.id}</Td>
                <Td title={item.name} whiteSpace="normal" >{item.name}</Td>
                <Td title={item.address} overflowX="hidden" overflow="hidden" textOverflow="ellipsis" >{item.address}</Td>
                <Td>{item.competition_date}</Td>
                <Td>{item.distance}</Td>
                <Td>{item.link}</Td>

                <Td><IconButton
                  mr="2"
                  colorScheme='red'
                  aria-label='Call Segun'
                  size='sm'
                  icon={<MdDelete />}
                  onClick={() => { openDelete(item.id, item.name) }}
                />
                  <IconButton
                    mr="2"
                    colorScheme='orange'
                    aria-label='Call Segun'
                    size='sm'
                    icon={<MdEdit />}
                    onClick={() => {
                      openEdit(item.id, item.name, item.address, item.competition_date, item.distance, item.link)
                    }}
                  /></Td>
              </Tr>
            ))}

          </Tbody>
          <Tfoot>
            <Tr>
            <Th w="2%">ID</Th>
              <Th w="10%" _hover={{ cursor: "pointer" }} onClick={handleSortTitle}>Nome    {sortedBy === "title" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "title" && sortOrder === "desc" && <FaSortUp />}</Th>
              <Th w="18%" >Luogo</Th>
              <Th w="5%" _hover={{ cursor: "pointer" }} onClick={handleSortCreated}>Data  {sortedBy === "created" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "created" && sortOrder === "desc" && <FaSortUp />}</Th>
              <Th w="5%" >Distanza</Th>
              <Th w="12%" >Link</Th>
              <Th w="5%"></Th>
            </Tr>

          </Tfoot>

        </Table>

      </TableContainer>}


      <Center w="100%" mb="4">
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page > 1) {
              setTableContent(allData.slice((page * 7) - 14, (page * 7) - 7));
              setPage(page - 1);
            }
          }}
          icon={<AiFillStepBackward />}
        />
        <Text ml="4" mr="4">
          {allData.length > 0 ? page : 0} / {Math.ceil(allData.length / 7)}
        </Text>
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page < Math.ceil(allData.length / 7)) {
              setTableContent(allData.slice((page * 7), (page * 7) + 7));
              setPage(page + 1);
            }
          }}
          icon={<AiFillStepForward />}
        />
      </Center>

      {/* END - TABLE */}

      {/* BEGIN - LOADING */}
      {loading &&

        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          backgroundColor="rgba(0, 0, 0, 0.5)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={9999}
          pointerEvents="none">
          <Box
            h="300"
            w="300"
            borderRadius="md"
            backgroundColor="white"
            zIndex={9999}
            display="flex"


          >
            <Flex h="300px" alignItems="center" justifyContent="center">
              <Stack spacing={5} w="300px">
                <Center>
                  <Text fontSize="xl" as="b" color="teal">Caricamento video</Text>
                </Center>
                <Center >
                  <Spinner
                    thickness='4px'
                    speed='0.65s'
                    emptyColor='gray.200'
                    color='blue.500'
                    size='xl'
                  />
                </Center>
                <Center>
                  <Progress hasStripe w="280px" value={updatedChunks / totalChunks * 100} max={100} />
                </Center>
                <Text>Parti caricate</Text>
                <span>{updatedChunks}/{totalChunks}</span>
              </Stack>
            </Flex>
          </Box>
        </Box>
      }

      {/* END - LOADING */}
    </div>

  );

}

export default CompetitionsList;